import type {
  CampusFormValues,
  CampusListItem,
  CampusListParams,
  CampusListResult,
  CampusBanner,
} from '@/types/campus.types';
import { cleanParams } from '@/utils/params.util';

import { apiClient } from './api.service';

export const campusesApi = {
  list: (params: CampusListParams): Promise<CampusListResult> =>
    apiClient
      .get<CampusListResult>('/admin/campuses', {
        params: cleanParams(params as unknown as Record<string, unknown>),
      })
      .then((r) => r.data),

  create: (data: CampusFormValues): Promise<CampusListItem> =>
    apiClient.post<CampusListItem>('/admin/campuses', data).then((r) => r.data),

  update: (id: string, data: Partial<CampusFormValues>): Promise<CampusListItem> =>
    apiClient.patch<CampusListItem>(`/admin/campuses/${id}`, data).then((r) => r.data),

  delete: (id: string): Promise<void> =>
    apiClient.delete(`/admin/campuses/${id}`).then(() => undefined),

  /** Puts one banner on every campus. Banner only — nothing else about a campus is shared. */
  applyBannerToAll: (banner: CampusBanner): Promise<{ updated: number }> =>
    apiClient.patch<{ updated: number }>('/admin/campuses/banner', { banner }).then((r) => r.data),
};
